import React from "react";
import { Grid } from "@mui/material";
import ImageUpload from "../../../../../components/ImageUpload";
import { useTranslation } from "react-i18next";
import { LOGO_UPLOAD, ABOUT_US_UPLOAD } from "../../../../../enums/ApiPaths";
import { LOGO, ABOUT_US } from "./enums/ImageType";
import { useParams } from "react-router-dom";
import * as keys from "../../../../../enums/QueryKeys";
import PageContentWrapper from "../../../../../components/wrappers/PageContentWrapper";
import { UPLOAD_ABOUT_US, UPLOAD_LOGO } from "../../../../../enums/PermissionTitles";
import { useRedirectIfNotOwnClinic } from "../../../../../hooks/useRedirectIfNotOwnClinic";
export default function ChangeLogoPage() {
  const { t } = useTranslation();
  const { id: clinicId } = useParams();
  useRedirectIfNotOwnClinic(clinicId);
  return (
    <PageContentWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <ImageUpload
            key={"logo_upload_key"}
            path={LOGO_UPLOAD + clinicId}
            fileType={LOGO}
            queryKey={keys.LOGO}
            uploadPermission={UPLOAD_LOGO}
            title={t("ChangeLogo")}
            description={t("ChangeLogoDoctorsLetterNote")}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <ImageUpload
            key={"banner_upload_key"}
            path={ABOUT_US_UPLOAD + clinicId}
            fileType={ABOUT_US}
            queryKey={keys.BANNER}
            uploadPermission={UPLOAD_ABOUT_US}
            title={t("ChangeAboutUsImage")}
            description={t("ChangeAboutUsImageNote")}
          />
        </Grid>
      </Grid>
    </PageContentWrapper>
  );
}
